import { create } from "zustand"

const useFetchPriceRequests = create((set) => ({
  priceRequests: [],
  precRequestCount: 0, // State variable to hold the count of objects in the array
  loading: true,
  setPriceRequests: (prices) =>
    set({ priceRequests: prices, precRequestCount: prices.length, loading: false }),
  setPriceRequestsLoading: (loadingState) => set({ loading: loadingState }),
}))

export default useFetchPriceRequests
